import { Icons, MenuRoute } from '@thirdspacelearning/library';

import App from '../App';
import { Dashboard, SessionFeedbackSurvey, NoMatch, Welcome } from '../screens';

export enum RoutePaths {
    DASHBOARD = '/',
    WELCOME = '/welcome',
    SESSION_FEEDBACK_SURVEY = '/survey/session-feedback',
    FALLBACK = '*',
}

export const routes = [
    {
        element: <App />,
        children: [
            {
                path: RoutePaths.DASHBOARD,
                element: <Dashboard />,
            },
            {
                path: RoutePaths.WELCOME,
                element: <Welcome />,
            },
            {
                path: RoutePaths.SESSION_FEEDBACK_SURVEY,
                element: <SessionFeedbackSurvey />,
            },
            {
                path: RoutePaths.FALLBACK,
                element: <NoMatch />,
            },
        ],
    },
];

export const menuRoutes: MenuRoute[][] = [
    [
        {
            key: RoutePaths.DASHBOARD,
            label: 'Home',
            icon: <Icons.Home />,
        },
    ],
];
